import { createClient } from '@supabase/supabase-js';

/**
 * La clave "publishable" es pública por diseño: lo que protege los datos son las reglas de la base de datos (RLS).
 * Aquí nunca va una clave de servicio ni de ningún proveedor: todo lo que cuesta dinero pasa por la API.
 */
const URL = import.meta.env.VITE_SUPABASE_URL ?? 'https://ssuxbuquhoztkeixsqdv.supabase.co';
const CLAVE = import.meta.env.VITE_SUPABASE_KEY ?? 'sb_publishable_JtjP9aFra1l5UmOrubUOcg_uGsejHvE';

export const supabase = createClient(URL, CLAVE, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
